export default __webpack_public_path__ + "static/media/suite-montanha2-3.9a837fbe.jpg";